import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AutoUpdateInfoComponent } from './auto-update-info.component';
import { SharedModule } from '../../../shared/shared.module';
import { IconsModule } from '../../../icons/icons.module';
import { DeferUpdateDialogComponent } from './defer-update-dialog/defer-update-dialog.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ErrorModule } from '../../../components/error/error.module';
import { PageLoaderModule } from '../../../components/page-loader/page-loader.module';
import { MatMenuModule } from '@angular/material/menu';



@NgModule({
  declarations: [AutoUpdateInfoComponent, DeferUpdateDialogComponent],
  imports: [
    CommonModule,
    SharedModule,
    IconsModule,
    ReactiveFormsModule,
    ErrorModule,
    PageLoaderModule,
    MatMenuModule
  ],
  exports: [AutoUpdateInfoComponent]
})
export class AutoUpdateInfoModule { }
